import { RbacFeature, RbacFeatureDetails, RbacApiPermission } from '@evidentid/tprm-portal-lib/models/rbac';

type ActionsFeatures = Extract<RbacFeature,
    | RbacFeature.actionsResolveEntityAction
    | RbacFeature.actionsResolveGlobalAction
    | RbacFeature.actionsViewDocument
    | RbacFeature.actionsViewMainActionsList
    | RbacFeature.contractExtractionGetData
    | RbacFeature.contractExtractionGetDocument
>;

export const ACTIONS_FEATURE_PERMISSIONS_MAP: Record<ActionsFeatures, RbacFeatureDetails> = {
    [RbacFeature.actionsViewMainActionsList]: {
        name: RbacFeature.actionsViewMainActionsList,
        label: 'View actions',
        requiredPermissions: [ RbacApiPermission.actionsGet ],
    },
    [RbacFeature.actionsViewDocument]: {
        name: RbacFeature.actionsViewDocument,
        label: 'View documents for actions',
        requiredPermissions: [ RbacApiPermission.actionsGet ],
    },
    [RbacFeature.actionsResolveEntityAction]: {
        name: RbacFeature.actionsResolveEntityAction,
        label: 'Resolve entity-level actions',
        requiredPermissions: [ RbacApiPermission.actionPostEntityResolve ],
    },
    [RbacFeature.actionsResolveGlobalAction]: {
        name: RbacFeature.actionsResolveGlobalAction,
        label: 'Resolve global-level actions',
        requiredPermissions: [ RbacApiPermission.actionPostGlobalResolve ],
    },
    [RbacFeature.contractExtractionGetData]: {
        name: RbacFeature.contractExtractionGetData,
        label: 'Review/approve extracted contracts',
        requiredPermissions: [ RbacApiPermission.contractExtractionGetData ],
    },
    [RbacFeature.contractExtractionGetDocument]: {
        name: RbacFeature.contractExtractionGetDocument,
        label: 'Upload contracts for review',
        requiredPermissions: [ RbacApiPermission.contractExtractionGetDocument ],
    },
};
